import { isMock } from '../config'
import { extrasMock } from './mock'
import { extrasReal } from './real'
import type { ExtrasService } from './types'

export const extrasService: ExtrasService = isMock('extras') ? extrasMock : extrasReal
export { kindOf } from './kind'
export type { PartnerProvider, PartnerStay } from './partner'
export type { CartItem, Extra, ExtraKind, ExtraOrder, ExtrasCheckout, ExtrasCheckoutSummary, ExtrasService, ExtrasStay, PriceUnit, Recommendation } from './types'
